module.exports = __webpack_public_path__ + "img/chevron-down.41517ee4.svg";